import * as React from 'react';

/**
 * @description AnimalInsurance icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { AnimalInsurance } from '@sravni/design-system-icons'
 *
 * <AnimalInsurance />
 * ```
 */
const AnimalInsurance = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "AnimalInsurance", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M3.065 10.389a1.42 1.42 0 1 0 .181-2.833 1.42 1.42 0 0 0-.181 2.833ZM7.85 6.542c.776-.113 1.282-1.044 1.13-2.078-.151-1.034-.903-1.78-1.679-1.667-.775.114-1.281 1.044-1.13 2.078.152 1.035.903 1.78 1.679 1.667ZM12.73 6.855c.755.212 1.596-.433 1.878-1.439.283-1.006-.1-1.994-.855-2.206-.755-.211-1.596.433-1.878 1.44-.282 1.006.1 1.993.856 2.205ZM16.752 11.278a1.42 1.42 0 1 0 .181-2.833 1.42 1.42 0 0 0-.181 2.833ZM7.142 10.508a3.942 3.942 0 0 1 5.565.356l1.823 2.073a2.76 2.76 0 0 1-3.506 4.18c-.97-.592-1.972-.657-3.007-.195a2.76 2.76 0 0 1-2.947-4.591l2.072-1.823Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { AnimalInsurance };
//# sourceMappingURL=AnimalInsurance.js.map
